/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, mediaQuery } from 'utils/styles';
import { aniFrameCountdownBarInitial } from 'components/content/shared/questionset/shared/animations/frame_countdownbar/initial';
import { aniFrameCountdownBarResult } from 'components/content/shared/questionset/shared/animations/frame_countdownbar/result';
import { aniProgressBarShareTopInitial } from 'components/content/shared/questionset/shared/animations/progressbar_share_top/initial';
import { aniProgressBarShareTopResult } from 'components/content/shared/questionset/shared/animations/progressbar_share_top/result';
import { aniQuestionInitial } from 'components/content/shared/questionset/shared/animations/question/initial';
import { aniQuestionResult } from 'components/content/shared/questionset/shared/animations/question/result';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE 1 QUESTION TYPE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    resultelements: {},
    answerset: {},
    typeset: {
        width: '100%',
        height: '100%',

        // ------ QUESTION ----- //
        '& .question': {
            transform: 'translate3d(-100%, 0, 0)', // pull off screen to start
            animationName: 'slideInLeft',
            animationDelay: '.1s',
            animationDuration: '.3s',
            animationFillMode: 'forwards'
        },

        // ------ ANSWER SET ----- //
        '& .answerset': {
            '& ul': {
                width: '100%',
                height: '85%',
                textAlign: 'center'
            },
            '& .answer': {
                display: 'inline-block',
                verticalAlign: 'top',
                textAlign: 'center',
                width: '32%',
                height: '100%',
                marginRight: '1%',
                '&:last-child': {
                    marginRight: '0'
                },
                '&:hover': {
                    animationName: 'pulse',
                    animationDelay: '0s',
                    animationDuration: '.5s'
                },
                '& .group': {
                    transition: 'all .3s linear 0s'
                },

                '& .graphic': {
                    opacity: '0', // pull off screen to start
                    animationName: 'fadeIn',
                    animationDelay: '0s',
                    animationDuration: '.3s',
                    animationFillMode: 'forwards'
                },
                '& .desc': {
                    opacity: '0', // pull off screen to start
                    animationName: 'fadeInDown',
                    animationDelay: '0s',
                    animationDuration: '.3s',
                    animationFillMode: 'forwards'
                },
                '&:nth-child(1)': {
                    '& .graphic': { animationDelay: '.9s' }, // delay each child animation slightly
                    '& .desc': { animationDelay: '1.5s' } // delay each child animation slightly
                },
                '&:nth-child(2)': {
                    '& .graphic': { animationDelay: '1.1s' },
                    '& .desc': { animationDelay: '1.8s' }
                },
                '&:nth-child(3)': {
                    '& .graphic': { animationDelay: '1.3s' },
                    '& .desc': { animationDelay: '2.1s' }
                },
                '&:nth-child(4)': {
                    '& .graphic': { animationDelay: '1.5s' },
                    '& .desc': { animationDelay: '2.4s' }
                }
            },
            // amount of answers change the styles (ex 2 answers vs 4 answers)
            '&.answeramount-2': {
                fontSize: '90%',
                '& .answer': { width: '46%' },
                '& .answer .graphic': { fontSize: '110%' }
            },
            '&.answeramount-4': {
                fontSize: '85%',
                '& .answer': { width: '23%' },
                '& .answer .graphic': { fontSize: '90%' }
            }
        },

        // !!!!!!!!!!!!!!!!!!! ~~~~~~~~~~~~~~~~~~~~~~~ ANIMATIONS ~~~~~~~~~~~~~~~~~~~~~~~ !!!!!!!!!!!!!!!!!!! //
        extend: [aniProgressBarShareTopInitial],
        // *** INITIAL STATE *** //
        '&.initial': {
            extend: [aniFrameCountdownBarInitial, aniQuestionInitial],
        },
        // *** RESULT STATE *** //
        '&.result': {
            extend: [aniFrameCountdownBarResult, aniQuestionResult, aniProgressBarShareTopResult],
            '& .answerset': {
                '& .answer': {
                    '& .group': {
                        transition: 'transform .5s linear .3s',
                        transform: 'scale(.7) translate(-72%, -105%)' // using for performance
                    },

                    '&.correct': {
                        '& .graphic': {
                            '& .fade': {
                                background: 'rgba(99, 145, 63, .7)', // green
                                borderColor: color.green,
                                transitionDelay: '2.4s'
                            }
                        }
                    },
                    '&.selected-true': {
                        '&.incorrect': {
                            '& .graphic': {
                                '& .fade': {
                                    background: 'rgba(165, 54, 54, .7)', // red
                                    borderColor: color.red,
                                    transitionDelay: '0s'
                                }
                            }
                        },
                        '&.correct': {
                            '& .graphic': {
                                '& .fade': {
                                    transitionDelay: '0s'
                                }
                            }
                        },
                        '& .graphic': {
                            '& .fade': {
                                borderColor: color.brand
                            }
                        }
                    },
                    '& .graphic': {
                        '& .fade': {
                            // animates color fade to show correct/incorrect choice
                            transition: 'all .3s linear 0s',
                            opacity: '1'
                        }
                    },
                    '& .desc': {
                        // removes text when shrinking the images
                        animationName: 'fadeOut',
                        animationDelay: '0s !important',
                        animationDuration: '.3s',
                        animationFillMode: 'forwards'
                    },
                    '& .percentagebar': {
                        width: '60%',
                        height: '47%'
                    }
                }

            }
        },
        // *** REWARDS STATE *** //
        '&.rewards': {
            // extend: [aniFrameCountdownBarResult, aniQuestionResult, aniProgressBarShareTopResult],

            '& .answerset, .resultelements, .question': {
                // removes text when shrinking the images
                display: 'none'
            },
            '& .rewardsmessage': { // This class name is in RewardsMessage component! It's a RewardsMessage wrapper div.
                display: 'block',
                width: '100%',
                height: '100%',
                opacity: '0', // pull off screen to start
                animationName: 'fadeIn',
                animationDelay: '0s',
                animationDuration: '.3s',
                animationFillMode: 'forwards'
            }
        }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.wide]: {
        typeset: {
            '& .answerset': {
                fontSize: '110%',
                '&.answeramount-2': {
                    fontSize: '120%'
                },
                '&.answeramount-4': {
                    fontSize: '105%',
                    '& .answer .graphic': { fontSize: '110%' }
                }
            },
            '&.result': {
                '& .answerset': {
                    '& .answer': {
                        '& .group': {
                            transform: 'scale(.7) translate(-72%, -103%)'
                        },
                        '& .percentagebar': {
                            height: '44%'
                        }
                    }
                }
            }
        }
    },
    [mediaQuery.medium]: {
        typeset: {
            '& .answerset': {
                fontSize: '100%',
                '&.answeramount-2': {
                    fontSize: '107%'
                },
                '&.answeramount-4': {
                    fontSize: '105%',
                    '& .answer .graphic': { fontSize: '95%' }
                }
            }
        }
    },
    [mediaQuery.thin]: {
        typeset: {
            '& .answerset': {
                '&.answeramount-2': { fontSize: '90%' },
                '&.answeramount-3': { fontSize: '90%' },
                '&.answeramount-4': { fontSize: '90%' }
            }
        }
    }
};
